export default __webpack_public_path__ + "static/internal-product-5d089e3e6105d6546e4223f51656c922.png";